import gql from 'graphql-tag';

export default gql`
  query publicFormFields($eventId: String!, $filter: [Filter], $language: Language!) {
    publicFormFields(eventId: $eventId, filter: $filter, language: $language) {
      id
      label
      type
      required
      unique
      ticketTypeIds
      icon
      data
    }
  }
`;



// WEBPACK FOOTER //
// ./src/site-render/src/graphql/queries/publicFormFields.js